/* eslint no-bitwise: [2, { allow: ["|", "&"] }] */
const crypto = require('crypto');

export default {
  state: {
    // userType: ['generalUser', 'softwareDeveloper', 'softwareReviewer', 'reviewerPhase1', 'reviewerPhase2', 'reviewerPhase3',
    //   'deviceAdmin', 'systemAdminLv1', 'systemAdminLv2', 'systemAdminLv3', 'systemAdminLv4'],
    // userTypeItem: [
    //   { text: 'generalUser', value: '1' },
    //   { text: 'softwareDeveloper', value: '2' },
    //   { text: 'softwareReviewer', value: '30' },
    //   { text: 'reviewerPhase1', value: '31' },
    //   { text: 'reviewerPhase2', value: '32' },
    //   { text: 'reviewerPhase3', value: '33' },
    //   { text: 'deviceAdmin', value: '4' },
    //   { text: 'systemAdminLv1', value: '5' },
    //   { text: 'systemAdminLv2', value: '6' },
    //   { text: 'systemAdminLv3', value: '7' },
    //   { text: 'systemAdminLv4', value: '8' },
    // ],
  },
  userTypeText(value) {
    // return this.state.userTypeItem.find((x) => (x.value === value)).text;
    switch (value) {
      default:
      case '1': return 'generalUser';
      case '2': return 'softwareDeveloper';
      case '30': return 'softwareReviewer';
      case '31': return 'reviewerPhase1';
      case '32': return 'reviewerPhase2';
      case '33': return 'reviewerPhase3';
      case '4': return 'deviceAdmin';
      case '5': return 'systemAdminLv1';
      case '6': return 'systemAdminLv2';
      case '7': return 'systemAdminLv3';
      case '8': return 'systemAdminLv4';
      case '9': return 'systemAdminLv5';
    }
  },
  userTypeValue(text) {
    // return this.state.userTypeItem.find((x) => (x.text === text)).value;
    switch (text) {
      default:
      case 'generalUser': return '1';
      case 'softwareDeveloper': return '2';
      case 'softwareReviewer': return '30';
      case 'reviewerPhase1': return '31';
      case 'reviewerPhase2': return '32';
      case 'reviewerPhase3': return '33';
      case 'deviceAdmin': return '4';
      case 'systemAdminLv1': return '5';
      case 'systemAdminLv2': return '6';
      case 'systemAdminLv3': return '7';
      case 'systemAdminLv4': return '8';
      case 'systemAdminLv5': return '9';
    }
  },
  uuid() {
    let d = Date.now();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
      d += performance.now(); // use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + this.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });
  },
  randomId() {
    const str = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'; // 基本字元
    const carryNum = 62; // 62進位
    // 轉62進位
    const id62 = (num) => {
      const modNum = [];
      let divNum = num;
      let value = num;
      let idStr = '';
      for (; ;) {
        if (divNum < carryNum) {
          modNum.push(divNum);
          break;
        }
        divNum = Math.floor(value / carryNum); // 商數計算
        modNum.push(value - (divNum * carryNum)); // 餘數計算
        value = divNum;
      }
      for (let idx = (modNum.length - 1); idx >= 0; idx -= 1) {
        idStr += str.substr(modNum[idx], 1);
      }
      return idStr;
    };
    return (id62(Date.now()) + id62(parseInt(this.random().toString().substr(2, 5), 10)));
  },
  random() {
    return crypto.randomBytes(1)[0] / 255;
  },
};
